import axios from "axios";

const certificateUrl = "/v2/api/certificate";

class CertificateService {
    static searchAllCertificates(urlParams) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${certificateUrl}${urlParams}`;
                const result = await axios.get(url);
                const pagingData = result.data;
                resolve(pagingData);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getCertificateById(certificateId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${certificateUrl}/${certificateId}`;
                const result = await axios.get(url);
                const certificateData = result.data;
                resolve(certificateData);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getCertificateByJobAndType({ job_sheet_id, certificate_type_id }) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${certificateUrl}/existing/by-job-and-type`;
                const result = await axios.get(url, {
                    params: {
                        jobSheetId: job_sheet_id,
                        certificateTypeId: certificate_type_id,
                    },
                });
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }


    static createCertificate(certificateData) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = certificateUrl;
                const result = await axios.post(url, certificateData);
                const createdCertificate = result.data;
                resolve(createdCertificate);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static updateCertificate(certificateId, updatedCertificateData) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${certificateUrl}/${certificateId}`;
                await axios.put(url, updatedCertificateData);
                resolve(`Certificate record with ID ${certificateId} updated successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static deleteCertificate(certificateId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${certificateUrl}/${certificateId}`;
                await axios.delete(url);
                resolve(`Certificate record with ID ${certificateId} deleted successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static createCertificateDocument(certificateId, document, isSignature = false) {
        return new Promise(async (resolve, reject) => {
            try {
                let docToUpload;

                if (isSignature) {
                    docToUpload = {
                        ...document,
                        filename: 'signature',
                    };
                } else {
                    docToUpload = {
                        filename: document.file[0].name,
                        content_type: document.file[0].type,
                        visibility: document.visibility,
                        category: document.category,
                        name: document.name,
                        description: document.description,
                        document_number: document.document_number,
                        is_published: true,
                    };
                }

                const result = await axios.post(
                    `${certificateUrl}/${certificateId}/documents`,
                    docToUpload
                );
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static deleteCertificateDocument(certificateId, documentId) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.delete(`${certificateUrl}/${certificateId}/documents/${documentId}`);
                resolve();
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getCertificateDocuments(certificateId, documentRole) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${certificateUrl}/${certificateId}/documents`;
                const result = await axios.get(url, {
                    params: documentRole ? { document_role: documentRole } : {},
                });
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static async getReport(certificateId, reportType) {
        try {
            const url = `${certificateUrl}/${certificateId}/report/${reportType}`;
            const response = await axios.post(url, {}, {responseType: 'blob'});
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : error.message);
        }
    }
}

export default CertificateService;
